import FooterDto from '../../api/models/Footer/FooterDto';

export const defaultFooterLinks: Array<FooterDto> = [
  {
    id: '1',
    order: 1,
    title: 'Kontakt',
    url: 'https://www.fjd.de/kontakt',
    footerType: 'CUSTOMIZABLE'
  },
  {
    id: '2',
    order: 2,
    title: 'Hilfe',
    url: 'https://www.fjd.de/kontakt',
    footerType: 'CUSTOMIZABLE'
  }
];
